<template>
    <div class="container">
        <h3 v-if="project.name">Project: {{ project.name }}</h3>
        <project-card :project="project" :projectRelease="projectRelease" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ProjectCard from './ProjectCard';

export default {
    components: {
        ProjectCard,
    },
    created() {
        this.fetchData();
    },
    computed: mapGetters(['project', 'projectRelease']),
    methods: {
        ...mapActions(['getProject', 'getProjectRelease']),
        async fetchData() {
            const { query: id } = this.$route.params;
            try {
                const project = await this.getProject(id);
                if (project.live_project_release) await this.getProjectRelease(project.live_project_release);
            } catch(e) {
                this.$notify.error({
                    title: "Couldn't fetch all project info :(",
                });
            }
        },
    },
    watch: {
        '$route.params'() {
            this.fetchData();
        }
    }
}
</script>

<style scoped>
.container > * + * {
    margin-top: 10px;
}
</style>
